<div class="card-body">
    <div id="emailSend-chart"></div>
</div>